import { DEFAULT_LANGUAGE, isLanguage, type Language } from "@ap/i18n";

const KEY = "ap.lang";

/** Persisted UI language (a preference, not a secret), else the token's ap_locale, else Arabic. */
export function initialLanguage(tokenLocale?: string): Language {
  try {
    const stored = localStorage.getItem(KEY);
    if (isLanguage(stored)) return stored;
  } catch {
    /* ignore */
  }
  const fromToken = tokenLocale?.slice(0, 2);
  return isLanguage(fromToken) ? fromToken : DEFAULT_LANGUAGE;
}

export function persistLanguage(lang: Language): void {
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    /* ignore */
  }
}
